'use client'

import * as React from 'react'

import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn } from '~/utils/tailwind-utils'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = ({
  ref,
  className,
  align = 'center',
  sideOffset = 8,
  preventAutoFocus,
  ...props
}: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
  className?: string
  preventAutoFocus?: boolean
} & {
  ref?: React.RefObject<React.ElementRef<
    typeof PopoverPrimitive.Content
  > | null>
}) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      side="bottom"
      sideOffset={sideOffset}
      onOpenAutoFocus={
        preventAutoFocus
          ? (e) => {
              e.preventDefault()
              // Focus the popover content itself so Tab starts inside it
              ;(e.currentTarget as HTMLElement)?.focus()
            }
          : undefined
      }
      className={cn('anchored z-50 w-64 p-4 outline-none md:w-80', className)}
      {...props}
    />
  </PopoverPrimitive.Portal>
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent }
